export class ExecutionCounter {
  #count = 0;
  #maxCount;

  constructor(maxCount) {
    this.#maxCount = maxCount;
  }

  increment() {
    if (this.#count < this.#maxCount) {
      this.#count += 1;
    }
  }

  isReachLimit() {
    return this.#count >= this.#maxCount;
  }

  resetCount() {
    this.#count = 0;
  }
}
